import type { MONDAY_TYPES } from "@onesolution/monday";
import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const updatesQuery = (params: {
	updateIds: string[];
}) =>
	requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
                query GetUpdate($updateIds: [ID!]) {
                    updates(ids: $updateIds) {
                        id
                        body
                        text_body
                        created_at
                        updated_at
                        creator {
                            id
                            name
                        }
                        item {
                            id
                            name
                        }
                        replies {
                            id
                            body
                            text_body
                            created_at
                        }
                    }
                }
                `,
			resultKey: "updates",
			outType: [] as Array<
				MONDAY_TYPES["base"] & {
					body: MONDAY_TYPES["text"];
					text_body: MONDAY_TYPES["text"];
					created_at: MONDAY_TYPES["date"];
					updated_at: MONDAY_TYPES["date"];
					creator: MONDAY_TYPES["base"];
					item: MONDAY_TYPES["base"];
					replies: (MONDAY_TYPES["base"] & {
						text_boy: MONDAY_TYPES["text"];
						created_at: MONDAY_TYPES["date"];
					})[];
					subitems: [];
				}
			>,
		},
		params,
	);
